import { Injectable, inject } from '@angular/core';
import { PageLoaderActions } from '@library/store/page-loader/page-loader.actions';
import { SettingsState } from '@library/utils/interfaces/settings-state.interface';
import { CallbackService } from '@library/utils/services/callback.service';
import { Actions, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, switchMap, take, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PageLoaderFacade {
  store$ = inject<Store<SettingsState>>(Store);
  callback = inject(CallbackService);
  actions$ = inject(Actions);

  isPageLoading$ = this.store$.pipe(select('isPageLoading'));

  /**
   * Handles the page loader: hides the web page loader, then sends the onPageLoaded callback
   * @param onCompleteAction Optional: if no parameters, hides the page loader, otherwise hides the page loader when the action is fired
   */
  handlePageLoader(onCompleteAction?: string) {
    this.store$.dispatch(PageLoaderActions.showPageLoader());

    if (!onCompleteAction) {
      this.hidePageLoader().subscribe(() => {
        this.callback.call(this.callback.list.onPageLoaded);
      });
    }
    else {
      this.actions$.pipe(
        ofType(onCompleteAction),
        first(),
        switchMap(() => this.hidePageLoader()),
        tap(() => {
          this.callback.call(this.callback.list.onPageLoaded);
        }),
      ).subscribe();
    }
  }

  showPageLoader() {
    this.store$.dispatch(PageLoaderActions.showPageLoader());
  }

  /**
   * Hides the page loader
   * @returns Observable on action of type HidePageLoaderSuccess when it is fired
   */
  hidePageLoader(): Observable<Action> {
    this.store$.dispatch(PageLoaderActions.hidePageLoader());

    return this.actions$.pipe(
      ofType(PageLoaderActions.hidePageLoaderSuccess),
      take(1),
    );
  }
}
